import { useAdminStore } from '@/store/admin'

// 设置路由守卫（登录校验、权限校验、会话维护）
export function setupRouterGuards(router) {
  const adminStore = useAdminStore()

  // 恢复一次本地信息
  try { adminStore.initAdmin?.() } catch {}

  const ensureAuthed = async () => {
    if (!adminStore.token) return false
    if (adminStore.adminInfo) return true
    try {
      await adminStore.verifyToken()
      return true
    } catch {
      return false
    }
  }

  router.beforeEach(async (to, _from, next) => {
    const requiresAuth = to.meta?.requiresAuth !== false

    // 已登录访问登录页 -> 跳转首页
    if (to.path === '/login') {
      if (await ensureAuthed()) return next('/')
      return next()
    }

    if (requiresAuth) {
      if (!(await ensureAuthed())) return next('/login')

      // 权限校验（具备任一即可通过）
      const perms = to.meta?.permissions || []
      if (Array.isArray(perms) && perms.length) {
        const ok = adminStore.hasAnyPermission?.(perms) ?? true
        if (!ok) return next('/403')
      }

      // 维护会话心跳
      try { adminStore.startSessionWatch?.() } catch {}
    }

    next()
  })
}

export default { setupRouterGuards }

